import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import { getNested } from '../../../node_modules/glo-shared-js/utils/helpers';
import { initModal } from '../../../node_modules/glo-shared-js/utils/modal-helpers';

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

(function() {
	let dates = [];
	let groupedLivestreams;
	const userTimezone = window.Intl ? window.Intl.DateTimeFormat().resolvedOptions().timeZone : dayjs.tz.guess();

	if (window.liveClasses) {
		// Prepare livestreams data for templates. Variable liveClasses is set in live-classes.html
		window.liveClasses.forEach(live => {
			let dateLive = dayjs(live.dateLive);

			if (userTimezone) live.dateLive = dayjs.tz(live.dateLive, userTimezone);

			live.formattedTimeLive = dayjs(dateLive).format('h:mm a');
			live.formattedDateLive = dayjs(dateLive).format('dddd MMMM D');
		});

		// Group livestreams by date
		groupedLivestreams = window.liveClasses.reduce(function(obj, val) {
			if (!obj[val.formattedDateLive]) obj[val.formattedDateLive] = [];
			obj[val.formattedDateLive].push(val);
			return obj;
		}, {});
	}

	// Get and display the next 7 days of the week starting from the current date, then format the date.
	for (let i = 0; i <= 6; i++) {
		const currentDate = dayjs();
		const dayOf = currentDate.add(i, 'day');
		let livestreams = groupedLivestreams ? getNested(groupedLivestreams, dayOf.startOf('day').format('dddd MMMM D')) : [];

		if (!livestreams) livestreams = [];

		dates.push({
			formattedDate: dayOf.format('DD'),
			formattedDay: dayOf.format('ddd'),
			formattedDayMobile: dayOf.format('dd').substr(0, 1),
			longFormatedDate: dayOf.format('dddd MMM DD'),
			dateId: dayOf.format('DD-MM-YYYY'),
			date: dayOf,
			isToday: currentDate.isSame(dayOf, 'day'),
			livestreams: livestreams
		});
	}

	// Render templates
	const dateCarousel = document.querySelector('.live-class__schedule-date-carousel');

	if (dateCarousel) {
		const scheduleNavTemplate = require('../../../server/views/partials/templates/live-classes-nav.html');
		dateCarousel.innerHTML = scheduleNavTemplate({
			dates
		});
	}

	const scheduleContentTemplate = require('../../../server/views/partials/templates/live-classes-content.html');
	document.querySelector('.live-class__schedule-card-container .content-container').innerHTML = scheduleContentTemplate({
		dates,
		cdn: CDN,
		showEmptyDays: !!document.getElementById('showEmptyDays')
	});

	if (typeof scrollToClick === 'object') scrollToClick.load();

	var urlParams = new URLSearchParams(window.location.search);

	if (urlParams.get('livestream-details')) {
		document.addEventListener('DOMContentLoaded', function() {
			var startTimeElement = document.querySelector('[data-date-live]');

			if (startTimeElement) {
				var dateLive = dayjs(startTimeElement.getAttribute('data-date-live'));

				if (userTimezone) dateLive = dateLive.tz(userTimezone);
				startTimeElement.innerText = dayjs(dateLive).format('h:mm a');
			}

			initModal();
		});
	}
})();
